import { forwardRef } from 'preact/compat'

export const SearchInput = forwardRef(({ onInput, onFocus, redirect, modalId, modalRole }, ref) => {
  return (
    <input
      ref={ref}
      onInput={onInput}
      onFocus={onFocus}
      className="w-full lg:w-[338px] bg-neutral-light border border-neutral-medium pl-2.25 focus:border-brand-black focus:shadow-none focus:outline-0"
      data-modal-id={modalId}
      data-modal-role={modalRole}
      type="text"
      name="query"
      placeholder="Search for products"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          if (redirect) {
            window.location.href = redirect
          } else {
            window.location.href = `/search?query=${e.target.value}`
          }
        }
      }}
    />
  )
})
